window.select2 = require("../../vendor/select2/js/select2.full");

export function initDefaultSelect2(selector = '.form-select') {
    $(selector).select2({
        theme: 'bootstrap-5',
        minimumResultsForSearch: Infinity,
        dropdownCssClass: 'custom-s2',
        width: 0,
    });
}